<div class="px-4 md:px-4 lg:p-0 relative z-10 h-[380px] mb-8 container mx-auto max-w-[1240px] lg:max-w-[1240px] 2xl:max-w-[1570px]">
    <!-- Encabezado del slider -->
    <div class="flex justify-between items-center mb-4 pb-3 border-b border-gray-200">
      <h2 class="text-xl font-bold">Vistos recientemente</h2>
      <div class="flex space-x-2">
        <!-- Flecha previa -->
        <button #prevBtn id="prevBtn"
          class="border border-gray-300 text-gray-300 p-1 w-8 h-8 rounded-full shadow-sm flex items-center justify-center transition-all duration-150 active:scale-90">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        <!-- Flecha siguiente -->
        <button #nextBtn id="nextBtn"
          class="border border-gray-300 text-gray-300 p-1 w-8 h-8 rounded-full shadow-sm flex items-center justify-center transition-all duration-150 active:scale-90">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>
  
    <!-- Carrusel -->
    <div #sliderWrapper id="slider-wrapper" class="mt-4">
      <!-- Slide 1 -->
      <div class="item inline-block">
        <div class="w-full rounded-[14px]">
          <div class="hover:z-10 relative group bg-white rounded-[14px] flex flex-col transition-all transform hover:scale-104">
            <!-- Imagen con progress bar -->
            <div class="relative z-0 overflow-hidden rounded-[14px] flex">
              <div class="image-container relative w-full rounded-[14px] overflow-hidden group">
                <img class="transition-transform duration-300 group-hover:scale-105"
                  src="https://netzunplus.s3.amazonaws.com/media/courses/photos/2021/11/19/dejgl-fa23bb8c-4976-11ec-8fe6-0a58a9feac02.webp?size=512"
                  alt="Imagen con efecto de zoom">
                <div class="overlay group-hover:opacity-0"></div>
              </div>
              <!-- Barra de progreso -->
              <div class="absolute bottom-0 left-0 w-full h-2 bg-gray-200 rounded-b-[14px] flex group-hover:hidden">
                <div class="h-2 bg-primary w-2/3 rounded-b-[14px]"></div>
              </div>
            </div>
            <div class="contenido-card flex flex-col gap-2 py-4 px-3 flex-1">
              <div class="flex justify-between items-center text-sm text-gray-700 gap-2 hidden group-hover:flex">
                <div class="flex items-center space-x-1 text-gray-500">
                  <i class="fa-solid fa-desktop text-gray-300"></i>
                  <span class="text-sm">Arte y diseño</span>
                </div>
                <div class="flex items-center space-x-1 text-gray-500">
                  <i class="fas fa-star text-yellow-500"></i>
                  <span>4.8</span>
                </div>
              </div>
              <div class="flex justify-between items-start gap-2">
                <h2 class="title-card text-md font-semibold text-gray-900 overflow-hidden text-ellipsis line-clamp-2 leading-[normal]">
                  How to prepare a business meeting that will make your success guaranteed
                </h2>
                <img src="https://api.myskillcamp.com/api/stockage/image/5fee40ce-730a-5097-bef8-ab6c08719d46.png?size=256"
                  class="h-6 object-contain" title="companyName">
              </div>
              <div class="flex items-center hidden group-hover:flex">
                <div class="w-full">
                  <div class="w-full h-2 bg-gray-200 rounded-[14px]">
                    <div class="h-2 bg-primary w-2/3 rounded-[14px]"></div>
                  </div>
                </div>
                <span class="ml-2 text-sm text-gray-700">66%</span>
              </div>
              <div class="hidden group-hover:block">
                <button class="w-full flex gap-2 items-center justify-center bg-secondary text-white py-2 px-4 rounded-lg transition">
                  <span class="text-sm">Reproducir</span>
                  <i class="fa-solid fa-play"></i>
                </button>
              </div>
              <div class="overflow-hidden hidden group-hover:block my-2">
                <p class="text-gray-700 text-sm description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque nec nunc id metus eleifend
                  tincidunt. Donec venenatis justo non turpis varius, ut volutpat purus interdum. Ut ac odio nec lorem
                  tincidunt vehicula.
                </p>
              </div>
              <div class="flex justify-between text-gray-500 gap-2 hidden group-hover:flex my-2">
                <span class="bg-gray-100 px-2 py-1 rounded-lg text-sm text-gray-500">
                  <i class="fa-solid fa-globe"></i> Inglés
                </span>
                <span class="flex items-center gap-1 text-sm">
                  <i class="fa-regular fa-bookmark"></i>
                </span>
              </div>
              <div class="flex justify-between text-gray-600 gap-2 group-hover:hidden">
                <span class="bg-gray-100 px-2 py-1 rounded-lg text-sm text-gray-500">Categoría</span>
                <span class="flex items-center gap-1 text-sm">
                  <i class="fas fa-check-circle text-gray-300 text-sm text-gray-500"></i> Suscrito
                </span>
              </div>
              <div class="flex justify-between items-center text-sm text-gray-700 gap-2 group-hover:hidden">
                <div class="flex items-center space-x-1 text-gray-500">
                  <i class="fa-solid fa-desktop text-gray-300"></i>
                  <span class="text-sm">Ruta de aprendizaje</span>
                  <span class="text-sm">3h 20min</span>
                </div>
                <div class="flex items-center space-x-1 text-gray-500">
                  <i class="fas fa-star text-yellow-500"></i>
                  <span>4.8</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item inline-block">
        <div class="w-full rounded-[14px]">
          <div class="hover:z-10 relative group bg-white rounded-[14px] flex flex-col transition-all transform hover:scale-104">
            <!-- Imagen con progress bar -->
            <div class="relative z-0 overflow-hidden rounded-[14px] flex">
              <div class="image-container relative w-full rounded-[14px] overflow-hidden group">
                <img class="transition-transform duration-300 group-hover:scale-105"
                  src="https://netzunplus.s3.amazonaws.com/media/courses/photos/2021/11/19/dejgl-fa23bb8c-4976-11ec-8fe6-0a58a9feac02.webp?size=512"
                  alt="Imagen con efecto de zoom">
                <div class="overlay group-hover:opacity-0"></div>
              </div>
              <!-- Barra de progreso -->
              <div class="absolute bottom-0 left-0 w-full h-2 bg-gray-200 rounded-b-[14px] flex group-hover:hidden">
                <div class="h-2 bg-primary w-2/3 rounded-b-[14px]"></div>
              </div>
            </div>
            <div class="contenido-card flex flex-col gap-2 py-4 px-3 flex-1">
              <div class="flex justify-between items-center text-sm text-gray-700 gap-2 hidden group-hover:flex">
                <div class="flex items-center space-x-1 text-gray-500">
                  <i class="fa-solid fa-desktop text-gray-300"></i>
                  <span class="text-sm">Arte y diseño</span>
                </div>
                <div class="flex items-center space-x-1 text-gray-500">
                  <i class="fas fa-star text-yellow-500"></i>
                  <span>4.8</span>
                </div>
              </div>
              <div class="flex justify-between items-start gap-2">
                <h2 class="title-card text-md font-semibold text-gray-900 overflow-hidden text-ellipsis line-clamp-2 leading-[normal]">
                  How to prepare a business meeting that will make your success guaranteed
                </h2>
                <img src="https://api.myskillcamp.com/api/stockage/image/5fee40ce-730a-5097-bef8-ab6c08719d46.png?size=256"
                  class="h-6 object-contain" title="companyName">
              </div>
              <div class="flex items-center hidden group-hover:flex">
                <div class="w-full">
                  <div class="w-full h-2 bg-gray-200 rounded-[14px]">
                    <div class="h-2 bg-primary w-2/3 rounded-[14px]"></div>
                  </div>
                </div>
                <span class="ml-2 text-sm text-gray-700">66%</span>
              </div>
              <div class="hidden group-hover:block">
                <button class="w-full flex gap-2 items-center justify-center bg-secondary text-white py-2 px-4 rounded-lg transition">
                  <span class="text-sm">Reproducir</span>
                  <i class="fa-solid fa-play"></i>
                </button>
              </div>
              <div class="overflow-hidden hidden group-hover:block my-2">
                <p class="text-gray-700 text-sm description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque nec nunc id metus eleifend
                  tincidunt. Donec venenatis justo non turpis varius, ut volutpat purus interdum. Ut ac odio nec lorem
                  tincidunt vehicula.
                </p>
              </div>
              <div class="flex justify-between text-gray-500 gap-2 hidden group-hover:flex my-2">
                <span class="bg-gray-100 px-2 py-1 rounded-lg text-sm text-gray-500">
                  <i class="fa-solid fa-globe"></i> Inglés
                </span>
                <span class="flex items-center gap-1 text-sm">
                  <i class="fa-regular fa-bookmark"></i>
                </span>
              </div>
              <div class="flex justify-between text-gray-600 gap-2 group-hover:hidden">
                <span class="bg-gray-100 px-2 py-1 rounded-lg text-sm text-gray-500">Categoría</span>
                <span class="flex items-center gap-1 text-sm">
                  <i class="fas fa-check-circle text-gray-300 text-sm text-gray-500"></i> Suscrito
                </span>
              </div>
              <div class="flex justify-between items-center text-sm text-gray-700 gap-2 group-hover:hidden">
                <div class="flex items-center space-x-1 text-gray-500">
                  <i class="fa-solid fa-desktop text-gray-300"></i>
                  <span class="text-sm">Ruta de aprendizaje</span>
                  <span class="text-sm">3h 20min</span>
                </div>
                <div class="flex items-center space-x-1 text-gray-500">
                  <i class="fas fa-star text-yellow-500"></i>
                  <span>4.8</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>